import { useState } from 'react';
import { Button, Group, Stack, Text } from '@mantine/core';
import { DateTimePicker } from '@mantine/dates';
import { ModalV2 } from '@dealstack/frontend/shared/components/ModalV2/ModalV2';
import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon/Icon.tsx';
import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';
import type { RescheduleModalProps as Props } from './RescheduleModal.types';

export const RescheduleModal = ({ initialNextFireAt, isSubmitting, onConfirm, onClose }: Props) => {
	const tMipManage = useTranslationMipManage();
	const [nextFireAt, setNextFireAt] = useState<Date | null>(new Date(initialNextFireAt));

	const handleConfirm = () => {
		if (!nextFireAt) {
			return;
		}
		onConfirm(nextFireAt.toISOString());
	};

	return (
		<ModalV2
			size="sm"
			onClose={onClose}
			reactModalProps={{ shouldCloseOnOverlayClick: !isSubmitting }}
		>
			<Stack gap="md">
				<Text fw={600} size="lg">
					{tMipManage('automated_emails.scheduled_queue.reschedule_modal.title')}
				</Text>
				<DateTimePicker
					label={tMipManage('automated_emails.scheduled_queue.reschedule_modal.label')}
					value={nextFireAt}
					onChange={setNextFireAt}
					minDate={new Date()}
					clearable={false}
					leftSection={<Icon variant="calendar" size="xl" />}
					// The calendar popover portals to <body>; without a z-index above
					// Z_INDEX.MODAL (999) it renders behind this modal. Matches the
					// shared MantineDateInput convention (withinPortal + zIndex 1000).
					popoverProps={{ withinPortal: true, zIndex: 1000 }}
				/>
				<Group justify="right" gap="xs">
					<Button variant="default" onClick={onClose} disabled={isSubmitting}>
						{tMipManage('automated_emails.scheduled_queue.reschedule_modal.cancel')}
					</Button>
					<Button
						onClick={handleConfirm}
						loading={isSubmitting}
						disabled={isSubmitting || !nextFireAt}
					>
						{tMipManage('automated_emails.scheduled_queue.reschedule_modal.confirm')}
					</Button>
				</Group>
			</Stack>
		</ModalV2>
	);
};
